module.exports = __webpack_public_path__ + "img/myaddon.c9527efe.webp";